// extracted by mini-css-extract-plugin
export default {"Section":"section_Section__ZJvdE","Section_name_primary":"section_Section_name_primary__okJMV","Section_name_secondary":"section_Section_name_secondary__4O5c-"};